import * as sanitizeHtmlLib from "sanitize-html";

// TODO Move to appropriate module when final structure will be set
/**
 * Sanitizes given HTML question string.
 * Questions texts are defined on the backend as HTML strings. We need to sanitize them to get rid of unwanted or dangerous HTML tags.
 * Only allowed tags are <b>, <a> and <br>.
 * @param {string} hmtlString String to be sanitized.
 */
export const sanitizeHTMLString = questionString =>
  questionString
    ? sanitizeHtmlLib(questionString, {
        allowedTags: ["b", "a", "br", "p", "i"],
        allowedAttributes: { a: ["href"] }
      })
    : "";

export const stringEndsWith = (string, end) => {
  if (!end || !string) return false;

  return string.lastIndexOf(end) + end.length === string.length;
};



// WEBPACK FOOTER //
// ./src/modules/utils/text-utils.js